import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

interface NeumorphicCircleProps {
  children: ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

const NeumorphicCircle = ({ children, className = "", size = "md" }: NeumorphicCircleProps) => {
  let theme = "dark";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  const getSizeStyles = () => {
    switch (size) {
      case "sm":
        return "w-24 h-24 md:w-32 md:h-32";
      case "md":
        return "w-24 h-24 md:w-72 md:h-72";
      case "lg":
        return "w-32 h-32 md:w-96 md:h-96";
    }
  };

  const getStyles = () => {
    if (theme === "dark") {
      return "bg-[#0a0a0a] shadow-[16px_16px_32px_#000000,-16px_-16px_32px_#0d0d0d]";
    } else {
      return "bg-[#f5f5f5] shadow-[16px_16px_32px_#d8d8d8,-16px_-16px_32px_#fefefe]";
    }
  };

  const hoverStyles = theme === "dark"
    ? "hover:shadow-[20px_20px_40px_#000000,-20px_-20px_40px_#0d0d0d]"
    : "hover:shadow-[20px_20px_40px_#d0d0d0,-20px_-20px_40px_#fefefe]";

  return (
    <div className={cn(
      "rounded-full overflow-hidden transition-all duration-300",
      getSizeStyles(),
      getStyles(),
      hoverStyles,
      "hover:scale-105",
      className
    )}>
      <div className="w-full h-full rounded-full overflow-hidden">
        {children}
      </div>
    </div>
  );
};

export default NeumorphicCircle;
